import PropTypes from 'prop-types';
import React from 'react';

import { InformationDiv, ButtonWrapper } from './styled';
import { files } from '../../libs/assets';

const Button = (props) => {
  const {
    showChevronIcon,
    onMouseEnter,
    onMouseLeave,
    iconPosition,
    borderless,
    loaderColor,
    transparent,
    className,
    closeable,
    wrapText,
    disabled,
    loading,
    onClick,
    onClose,
    variant,
    target,
    title,
    block,
    type,
    href,
    text,
    info,
    icon,
    size,
    rel
  } = props;

  const classNames = [
    showChevronIcon ? 'show-chevron-icon' : '',
    href && disabled ? 'disabled' : '',
    transparent ? 'transparent' : '',
    borderless ? 'borderless' : '',
    wrapText ? 'wrap-text' : '',
    block ? 'block' : '',
    className,
    variant,
    size
  ].join(' ').trim();

  return (
    <ButtonWrapper>
      {info && (
        <InformationDiv position={`right`} className="tooltip">
          {info}
        </InformationDiv>
      )}

      {href ? (
        <a aria-disabled={disabled} className={classNames} target={target} title={title} href={href} rel={rel}>
          {iconPosition === 'start' && icon && <img src={icon} alt="button_icon" />}

          {text}

          {iconPosition === 'end' && icon && <img src={icon} alt="button_icon" />}

          {closeable && (
            <span className="close-icon" onClick={onClose}>
              <img src={files.closeIcon} alt="close_icon" />
            </span>
          )}

          {showChevronIcon && (
            <span className="chevron-icon">
              <img src={files.rightChevronIconBlue} alt="chevron_icon" />
            </span>
          )}
        </a>
      ) : (
        <button
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          className={classNames}
          disabled={disabled}
          onClick={onClick}
          title={title}
          type={type}
        >
          {loading ? (
            <svg width="20" height="20" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
              <g fill="none" fillRule="evenodd" stroke={disabled ? '#9ca3af' : loaderColor}>
                <g transform="translate(1 1)" strokeWidth="3">
                  <circle strokeOpacity=".2" cx="18" cy="18" r="18" />
                  <path d="M36 18c0-9.94-8.06-18-18-18">
                    <animateTransform
                      attributeName="transform"
                      repeatCount="indefinite"
                      to="360 18 18"
                      from="0 18 18"
                      type="rotate"
                      dur=".5s"
                    />
                  </path>
                </g>
              </g>
            </svg>
          ) : (
            iconPosition === 'start' && icon && <img src={icon} alt="button_icon" />
          )}

          {text && <span className="button-text">{text}</span>}

          {iconPosition === 'end' && icon && <img src={icon} alt="button_icon" />}

          {closeable && (
            <span className="close-icon" onClick={onClose}>
              <img src={files.closeIcon} alt="close_icon" />
            </span>
          )}

          {showChevronIcon && (
            <span className="chevron-icon">
              <img src={files.rightChevronIconBlue} alt="chevron_icon" />
            </span>
          )}
        </button>
      )}
    </ButtonWrapper>
  );
};

Button.defaultProps = {
  rel: 'noopener noreferrer',
  onMouseEnter: () => null,
  onMouseLeave: () => null,
  showChevronIcon: false,
  iconPosition: 'start',
  loaderColor: 'white',
  variant: 'outlined',
  onClick: () => null,
  onClose: () => null,
  transparent: false,
  borderless: false,
  closeable: false,
  target: '_blank',
  size: 'default',
  disabled: false,
  wrapText: false,
  loading: false,
  type: 'button',
  className: '',
  block: false,
  title: '',
  icon: '',
  text: '',
  href: '',
  info: '',
};

Button.propTypes = {
  variant: PropTypes.oneOf(['filled', 'outlined', 'grayed', 'text', 'error', 'link', 'icon']),
  target: PropTypes.oneOf(['_parent', '_blank', '_self', '_top']),
  size: PropTypes.oneOf(['tiny', 'small', 'large', 'default']),
  iconPosition: PropTypes.oneOf(['start', 'end']),
  type: PropTypes.oneOf(['submit', 'button']),
  showChevronIcon: PropTypes.bool,
  loaderColor: PropTypes.string,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  className: PropTypes.string,
  transparent: PropTypes.bool,
  borderless: PropTypes.bool,
  closeable: PropTypes.bool,
  disabled: PropTypes.bool,
  wrapText: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  title: PropTypes.string,
  text: PropTypes.string,
  icon: PropTypes.string,
  href: PropTypes.string,
  info: PropTypes.string,
  block: PropTypes.bool,
  rel: PropTypes.string
};

export default Button;